'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./UniversalUploaderItem.scss');

var UniversalUploaderItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UniversalUploaderItem, _Component);

  function UniversalUploaderItem() {
    (0, _classCallCheck3.default)(this, UniversalUploaderItem);
    return (0, _possibleConstructorReturn3.default)(this, (UniversalUploaderItem.__proto__ || (0, _getPrototypeOf2.default)(UniversalUploaderItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(UniversalUploaderItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          maxSize = _props.maxSize,
          showThumb = _props.showThumb,
          uploaderThumbNode = _props.uploaderThumbNode,
          fileNameNode = _props.fileNameNode,
          fileExtNode = _props.fileExtNode,
          uploadStatusNode = _props.uploadStatusNode,
          fileSizeNode = _props.fileSizeNode,
          progressBarNode = _props.progressBarNode,
          uploadStatusIconNode = _props.uploadStatusIconNode;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.uploaderItem, className) },
        _react2.default.createElement(
          'div',
          { className: 'table' },
          _react2.default.createElement(
            'div',
            { className: 'table-cell width-perc-1' },
            showThumb ? _react2.default.createElement(
              'div',
              { style: { minHeight: maxSize + 'px' }, className: styles.thumbContainer },
              uploaderThumbNode
            ) : _react2.default.createElement(
              _components.FileTypeThumb,
              null,
              fileExtNode
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'table-cell padding-left-10 pos-rel' },
            _react2.default.createElement(
              'div',
              { className: 'width-perc-100' },
              _react2.default.createElement(
                'span',
                { className: styles.fileName },
                fileNameNode
              ),
              _react2.default.createElement(
                'div',
                { className: styles.uploadStatus },
                uploadStatusNode
              ),
              _react2.default.createElement(
                'span',
                { className: styles.fileSize },
                fileSizeNode
              )
            ),
            !!progressBarNode && progressBarNode
          ),
          !!uploadStatusIconNode && _react2.default.createElement(
            'div',
            { className: 'table-cell width-perc-1 vertical-bottom' },
            uploadStatusIconNode
          )
        )
      );
    }
  }]);
  return UniversalUploaderItem;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  fileExtNode: _propTypes2.default.node,
  fileNameNode: _propTypes2.default.node,
  fileSizeNode: _propTypes2.default.node,
  maxSize: _propTypes2.default.number,
  progressBarNode: _propTypes2.default.node,
  showThumb: _propTypes2.default.bool,
  uploaderThumbNode: _propTypes2.default.node,
  uploadStatusIconNode: _propTypes2.default.node,
  uploadStatusNode: _propTypes2.default.node
}, _class.defaultProps = {
  maxSize: 70
}, _temp);
exports.default = UniversalUploaderItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UniversalUploaderItem/UniversalUploaderItem.js
// module id = 2132
// module chunks = 1